export const i18nLanguageMapping = new Map<string, string>([
  ['fr', 'fr-FR'],
  ['es', 'es-LA'],
  ['pt-br', 'pt-BR'],
  ['sv', 'sv-SE'],
  ['it', 'it-IT'],
  ['pl', 'pl-PL']
]);

export const templateLanguageMapping = new Map<string, string>([
  ['fr-FR', 'fr'],
  ['es-LA', 'es'],
  ['pt-BR', 'pt-br'],
  ['sv-SE', 'sv'],
  ['it-IT', 'it'],
  ['pl-PL', 'pl']
]);
